import theme from '../../theme/theme';

const AnomalyItem = ({ title, description, color }) => (
    <div style={{
        display: 'flex',
        gap: '0.75rem',
        alignItems: 'flex-start',
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        borderLeft: `3px solid ${color || theme.palette.warning.main}`,
        backgroundColor: 'rgba(246, 166, 35, 0.05)',
        borderRadius: theme.shape.borderRadius / 2
    }}>
        <div style={{ flexShrink: 0, marginTop: '0.15rem'}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color || theme.palette.warning.main} strokeWidth="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
        </div>
        <div style={{ flex: 1 }}>
            <div style={{
                fontSize: '0.9rem',
                fontWeight: 600,
                color: theme.palette.text.primary,
                marginBottom: '0.25rem'
            }}>
                {title || 'Anomaly'}
            </div>
            <div style={{
                fontSize: '0.85rem',
                color: theme.palette.text.secondary,
                lineHeight: '1.4'
            }}>
                {description}
            </div>
        </div>
    </div>
);

const AnomalyPanel = ({ anomalies, loading }) => {
    if (loading) {
        return (
            <div style={{
                padding: theme.spacing(2),
                color: theme.palette.text.secondary
            }}>
                Checking anomalies...
            </div>
        );
    }

    // Use backend data
    const list = anomalies || [];

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(2),
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
        }}>
            <div style={{ marginBottom: theme.spacing(1.5) }}>
                <h3 style={{
                    fontSize: '1.2rem',
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                    margin: 0
                }}>
                    Anomalies Detected
                </h3>
                <p style={{
                    fontSize: '0.85rem',
                    color: theme.palette.text.secondary,
                    margin: '0.25rem 0 0 0'
                }}>
                    Unusual weather events and deviations
                </p>
            </div>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
                flex: 1
            }}>
                {list.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: theme.spacing(3),
                        color: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default,
                        borderRadius: theme.shape.borderRadius / 2
                    }}>
                        <svg
                            width="48"
                            height="48"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke={theme.palette.success.main}
                            strokeWidth="1.5"
                            style={{ margin: '0 auto 1rem', display: 'block' }}
                        >
                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p style={{ margin: 0, color: theme.palette.text.secondary }}>
                            No anomalies detected.
                        </p>
                    </div>
                ) : (
                    list.map((item, idx) => (
                        <AnomalyItem
                            key={idx}
                            title={item.title || "Anomaly"}
                            description={item.description || item.message || "Anomaly detected"}
                            color={theme.palette.warning.main}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default AnomalyPanel;
